import React from 'react';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import TimeUtil from 'time';
import StartTimeMixin from 'main/components/show/cuesheet/startTimeMixin';
import OverrideIcon from 'main/components/show/cuesheet/overrideIcon.jsx';

import Tappable from 'react-tappable';

export default React.createClass({
  mixins: [StartTimeMixin, PureRenderMixin],

  render() {
    const { rowIndex, item } = this.props;

    if (!item.get('displayStartTimeClock')) return null;

    return (
      <Tappable
        onTap={() =>
          CuesheetCellActions.startEditingItemCell(
            rowIndex,
            EditableCellTypes.ItemStartTime,
          )
        }
      >
        {this._getDisplayNode()}
      </Tappable>
    );
  },

  _getDisplayNode() {
    const { twentyFourHourClock } = this.props;

    return (
      <span className="csr-start-time-cell">
        <OverrideIcon
          field="startOn"
          rowIndex={this.props.rowIndex}
          item={this.props.item}
        />
        {TimeUtil.getShorthandTimeUTC(
          this._getStartTimeValue(),
          twentyFourHourClock,
        )}
      </span>
    );
  },
});
